import { gql } from '@apollo/client';

export const SHARE_FIELDS = gql`
  fragment ShareFields on Share {
    id
    groupId
    organizationPlaylistId
    type
    userId
    __typename
  }
`;

export const PLAYLIST_FIELDS = gql`
  fragment PlaylistFields on Playlist {
    id
    shortId
    shareType
    status
    __typename
  }
`;
